<template>
  <div class="modal fade modal-job-public-details" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Job Details
        </div><!-- /.modal-header -->
        <div class="modal-body">

          <p class="material-details">
            <strong>Job Reference</strong><br />
            {{ job.number }}
          </p>

          <h3 class="m-b-sm">
            <template v-if="jobHasEnoughDetails">
              {{ job.commodity_and_location_with_quantity }}
            </template>
          </h3>

          <p class="material-details">
            <strong>Approx Distance</strong><br />
            {{ distance }}
          </p>

          <p class="material-details" v-if="jobHasCoordinator">
            <strong>Coordinator:</strong><br />
            {{ job.coordinator.profile.full_name }} {{ job.coordinator.mobile }}
          </p>

          <p class="material-details">
            <strong>Notes</strong><br />
            {{ job.notes }}
          </p>

          <div class="map-container">
            <distance-map ref="map" :location-from="job.location_from" :location-to="job.location_to"></distance-map>
          </div>

        </div><!-- /.modal-body -->
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6 footer-left">
              <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
            </div>
            <div class="col-sm-6 footer-right">
            </div>
          </div><!-- /.row -->
        </div><!-- /.modal-footer -->
      </div><!-- /.modal-content -->
    </div>
  </div><!-- /.modal -->
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { RESET_JOB } from 'vx/mutations'
import { isObject } from 'lodash'
import DistanceMap from './DistanceMap'
import $ from 'jquery'

export default {
  data () {
    return {
      distance: '-'
    }
  },

  components: {
    DistanceMap
  },

  computed: {
    ...mapGetters('job', { job: 'jobDecorated', haveJob: 'haveJob' }),

    /**
     * Determine if the job has enough details to display the commodity and location
     */
    jobHasEnoughDetails () {
      return isObject(this.job.commodity) ||
        isObject(this.job.location_from) ||
        isObject(this.job.location_to)
    },

    /**
     * Determine if the job has a coordinator so we can display coordinator details
     */
    jobHasCoordinator () {
      return this.job.coordinator
    }
  },

  created () {
    this[RESET_JOB]()

    this.$watch('job', () => {
      this.distance = '-'
      if (this.job.id) {
        this.getJobDistance(this.job.id).then(response => {
          this.distance = response.data.distance
        })
      }
    })
  },

  /**
   * Bind event listener.
   *
   * @return void
   */
  mounted () {
    $(this.$el).on('hidden.bs.modal', this[RESET_JOB])
    $(this.$el).on('shown.bs.modal', () => {
      this.$refs.map.$emit('refresh')
    })
  },

  /**
   * Remove event listeners.
   *
   * @return void
   */
  beforeDestroy () {
    $(this.$el).off('hidden.bs.modal', this[RESET_JOB])
  },

  methods: {
    ...mapActions('job', ['getJobDistance']),
    ...mapMutations('job', [RESET_JOB])
  }
}
</script>



// WEBPACK FOOTER //
// JobBoardModal.vue?ca11d004